export interface UnderminingRow {
  from_direction: number;
  to_direction: number;
  depth_cm: number;
}

export interface SizeState {
  na: boolean;
  length: string;
  width: string;
  depth: string;
}

export interface ThicknessState {
  value: string;
  other: string;
  notAssessedReason: string;
}

export interface EdgesState {
  notAssessed: boolean;
  notAssessedReason: string;
  values: string[];
}

export interface DrainageState {
  value: string;
  type: string;
  typeOther: string;
  amount: string;
  notAssessedReason: string;
}

export interface OdorState {
  value: string;
  type: string;
  typeOther: string;
  notAssessedReason: string;
}

export interface WoundBedState {
  notAssessed: boolean;
  notAssessedReason: string;
  pcts: Record<string, string>;
  other: boolean;
  otherText: string;
}

export interface SurroundingTissueState {
  notAssessed: boolean;
  notAssessedReason: string;
  values: string[];
  otherText: string;
}

export interface UnderminingState {
  value: string;
  notAssessedReason: string;
  rows: UnderminingRow[];
}

export interface TunnelingState {
  value: string;
  notAssessedReason: string;
  direction: string;
  depth: string;
}

export interface PainState {
  present: boolean;
  level: string;
}

export interface NotesState {
  woundCareNotes: string;
  treatmentPerformed: string;
  patientResponse: string;
  additionalInfo: string;
}

export const DEFAULT_SIZE: SizeState = {
  na: false,
  length: '',
  width: '',
  depth: '',
};
export const DEFAULT_THICKNESS: ThicknessState = {
  value: '',
  other: '',
  notAssessedReason: '',
};
export const DEFAULT_EDGES: EdgesState = {
  notAssessed: false,
  notAssessedReason: '',
  values: [],
};
export const DEFAULT_DRAINAGE: DrainageState = {
  value: '',
  type: '',
  typeOther: '',
  amount: '',
  notAssessedReason: '',
};
export const DEFAULT_ODOR: OdorState = {
  value: '',
  type: '',
  typeOther: '',
  notAssessedReason: '',
};
export const DEFAULT_WOUND_BED: WoundBedState = {
  notAssessed: false,
  notAssessedReason: '',
  pcts: {
    wound_bed_pink_red_pct: '',
    wound_bed_granulation_pct: '',
    wound_bed_slough_pct: '',
    wound_bed_eschar_pct: '',
    wound_bed_necrotic_pct: '',
  },
  other: false,
  otherText: '',
};
export const DEFAULT_SURROUNDING_TISSUE: SurroundingTissueState = {
  notAssessed: false,
  notAssessedReason: '',
  values: [],
  otherText: '',
};
export const DEFAULT_UNDERMINING: UnderminingState = {
  value: '',
  notAssessedReason: '',
  rows: [],
};
export const DEFAULT_TUNNELING: TunnelingState = {
  value: '',
  notAssessedReason: '',
  direction: '',
  depth: '',
};
export const DEFAULT_PAIN: PainState = { present: false, level: '' };
export const DEFAULT_NOTES: NotesState = {
  woundCareNotes: '',
  treatmentPerformed: '',
  patientResponse: '',
  additionalInfo: '',
};
